// import { ClientBankSetup } from "components/ClientBank";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { ClientBankSetup } from "../../../components/Client/ClientBankSetup";

export const ClientBankSetupPage = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Client Bank Setup"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[
				// { text: "accountants", navigateTo: "/accountants/list" },
				{ text: "Client Bank Setup", navigateTo: "/clients/bank-setup" },
			]}
			mainContents={<ClientBankSetup />}
		/>
	);
};
